import React, { ReactNode } from 'react';
import styled from 'styled-components';

interface StyledPageContentProps {
  $padding?: string;
  minHeight?: string;
}

interface PageContentProps {
  padding?: string;
  minHeight?: number;
  widePageContent?: boolean;
  children: ReactNode;
}

const StyledPageContent = styled.div<StyledPageContentProps>`
  min-width: 300px;
  max-width: 1400px;
  margin: 0 auto;
  padding: ${({ $padding }) => $padding || '60px 16px;'};
  min-height: ${({ minHeight }) => minHeight || 'calc(100vh - 64px)'};
`;

const StyledWidePageContent = styled.div<StyledPageContentProps>`
  width: 100%;
  min-width: 300px;
  margin: 0 auto;
  padding: ${({ $padding }) => $padding || '32px 16px;'};
  min-height: calc(100vh - 64px);
`;

export const PageContent: React.FC<PageContentProps> = ({ children, minHeight, padding, widePageContent = false }) => (
  <>
    {widePageContent ? (
      <StyledWidePageContent $padding={padding}>{children}</StyledWidePageContent>
    ) : (
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      <StyledPageContent minHeight={minHeight} $padding={padding}>
        {children}
      </StyledPageContent>
    )}
  </>
);
